import { useState, useEffect } from 'react';
import { api, endpoints } from '../config/api';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';
import { useStreamingStatus } from '../hooks/useStreamingStatus';
import { PageTitle, PromotionsCarousel } from '../components';

function StreamingPage() {
  const { config } = useConfig();
  const { isLive, isConnected } = useStreamingStatus({ autoWatch: true });
  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');
  const [streamEmbedUrl, setStreamEmbedUrl] = useState(null);
  const [promociones, setPromociones] = useState([]);

  useEffect(() => {
    if (config?.headerVideo) {
      setStreamEmbedUrl(config.headerVideo);
    }
  }, [config]);

  useEffect(() => {
    const load = async () => {
      try {
        const ev = await api.get(endpoints.eventActive());
        if (ev?.id) {
          const data = await api.get(endpoints.promotionsByEvent(ev.id));
          setPromociones(Array.isArray(data) ? data : []);
        }
      } catch {
        setPromociones([]);
      }
    };
    load();
  }, []);

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      <div className="relative z-0 flex flex-col flex-1 items-center justify-between px-4 pt-6">
        <div className="relative z-0 flex flex-col flex-col items-center justify-between px-4 pt-10">
          <div className="relative w-full overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[180px] sm:min-h-[250px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0 pl-2 sm:pl-4 mr-12 sm:mr-20">
                <img src={config.headerImage} alt="37 Simposio" className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left" />
              </div>
            )}
            {mujerKvUrl && (
              <div className="absolute right-0 bottom-0 h-full w-1/3 sm:w-1/4 flex justify-center items-end pointer-events-none">
                <img src={mujerKvUrl} alt="" className="h-[100%] sm:h-[110%] w-auto object-contain object-bottom mix-blend-screen brightness-110 opacity-50 sm:opacity-60" />
              </div>
            )}
          </div>
        </div>

        <PageTitle>Streaming</PageTitle>

        <div className="flex-1 w-full max-w-4xl mx-auto p-4 overflow-y-auto space-y-6">
          <div className="p-4">
            <div className="flex items-center gap-2 mb-2">
              {isLive && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-500 text-white text-xs font-semibold animate-pulse">
                  <span className="w-2 h-2 rounded-full bg-white" />
                  EN VIVO
                </span>
              )}
              {isConnected && !isLive && (
                <span className="text-xs text-gray-500">En espera de transmisión</span>
              )}
            </div>
            <div className="rounded-lg overflow-hidden aspect-video flex items-center justify-center relative">
              {streamEmbedUrl ? (
                <iframe
                  src={streamEmbedUrl}
                  title="StreamYard - Transmisión en vivo"
                  className="w-full h-full min-h-[300px]"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <div className="text-white/70 text-center p-8">
                  <p className="text-lg mb-2">0:00</p>
                  <p className="text-sm">El streaming estará disponible próximamente</p>
                </div>
              )}
            </div>
          </div>

          {promociones.length > 0 && (
            <div className="p-4">
              <h3 className="text-sm font-semibold text-gray-600 mb-3 uppercase tracking-wide">Promociones</h3>
              <PromotionsCarousel items={promociones} autoPlayInterval={6000} />
            </div>
          )}
        </div>
      </div>

      <div className="relative z-20 flex justify-between items-end px-4 py-6 pb-8 gap-4">
        <div className="flex flex-col items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img src={logoMedicina} alt="Medicina Biorreguladora de Sistemas" className="h-[110%] w-auto sm:h-20 object-contain object-left max-w-[75%]" />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-8 sm:h-10 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default StreamingPage;
